// Generated from src/img/svg/s5.svg

export const S5 = (props) => {
  return (
    <svg viewBox="0 0 26 13" {...props}>
      <rect fill="#00537f" height="13" rx="6.5" width="25" x=".5" />
      <g
        aria-label="S5"
        style={{
          fill: "#fff",
          fontFamily: 'HelveticaNeue-Bold,"Helvetica Neue"',
          fontSize: "10px",
          fontWeight: "700",
          transform: "translate(.5px,0)",
        }}
      >
        <path d="M6.715 7.63h1.52q0 .67.48 1.02.41.3 1.1.3.54 0 .9-.17.49-.23.49-.72 0-.61-1.1-.92-1.9-.54-2.05-.62-1.1-.53-1.1-1.67 0-1.03.85-1.63.76-.53 1.82-.53 1.23 0 1.99.53.87.61.87 1.77h-1.52q-.06-1.08-1.41-1.08-.43 0-.73.18-.35.22-.35.63 0 .39.39.57.3.14 1.74.51.84.21 1.25.48.87.56.87 1.6 0 1.02-.76 1.64-.8.65-2.21.65-1.29 0-2.12-.61-.93-.69-.92-1.93" />
        <path
          d="M18.42 3.001h-3.823l-.675 3.785h1.252c.274-.381.548-.548 1.047-.548.743 0 1.183.568 1.183 1.282 0 .684-.46 1.32-1.183 1.32-.617 0-1.057-.411-1.125-1.027h-1.389c.03 1.437 1.213 2.17 2.543 2.17 1.369.03 2.543-1.055 2.543-2.463 0-1.282-.763-2.328-2.113-2.328-.547 0-.958.147-1.34.528l-.02-.02.275-1.554h2.826z"
          style={{ fill: "#fff" }}
        />
      </g>
    </svg>
  );
};
